<div
  class="header"
  appScrollSync
  [sourceName]=`${resourceParamsKey}-header`
  [syncGroup]="resourceParamsKey"
>
  @for (columnParam of columnParamsStateService.getColumnParamsByKey(resourceParamsKey); track columnParam.key;  let index = $index) {
    @if (isNeedCheckbox(index)) {
      <div class="table-cell header-cell header-checkbox sticky">
        <mat-checkbox
          [checked]="getChecked()"
          (change)="updateChecked($event.checked)"
        ></mat-checkbox>
      </div>
    }
    @if (isColumnDisplayed(columnParam)) {
      <div
        #headerCell
        class="table-cell header-cell"
        [style.left.px]="columnParam.leftPositionForStickyColumn"
        [class]="{
         'with-background': columnParam.enableBackgroundColour,
         'sortable': columnParam.sortable,
         'sorted-desc': isCurrentColumnSorted(columnParam, 'desc'),
         'sorted-asc': isCurrentColumnSorted(columnParam, 'asc'),
         'modal-padding-inline': columnParam.type === 'MODAL',
         'sticky': columnParam.sticky
        }"
        [style.max-width.px]="getWidth(columnParam)"
        [style.min-width.px]="getWidth(columnParam)"
      >
        <div
          class="column-name"
          [class.resize-column]="isResizeColumn && !isEditModeActive"
          [attr.data-column]="columnParam.key"
          (mousedown)="!columnParam.sticky && handleResizeStart($event, columnParam)"
        >
          <div
            matTooltipClass="custom-tooltip"
            [matTooltip]="columnParam.name"
            [matTooltipShowDelay]="500"
            [class]="{
               'pointer': columnParam.sortable,
               'repeats-column': modalStatesService.hasOpenModals()
             }"
            (click)=" handleSortingChange(columnParam)"
          >
            {{ columnParam.name }}
          </div>
        </div>
        @if (!modalStatesService.hasOpenModals()) {
          <button
            class="pin-button"
            (click)="handleToggleColumnStick(resourceParamsKey, columnParam)"
          >
            <i
              [class]="{
                 'pin-icon': !columnParam.sticky,
                 'unpin-icon': columnParam.sticky
               }"
            ></i>
          </button>
        }
      </div>
    }
    @if (columnParam.separated) {
      <div class="separator-column"></div>
    }
    @if (columnParam.hiddenGroupPlaceholder) {
      <div
        app-hidden-group
        class="hidden-group-placeholder"
        [resourceParamsKey]="resourceParamsKey"
        [columnParams]="columnParam"
      ></div>
    }
  }
  @if (isAnyTableActionAvailable && noEmptyTableData) {
    <div class="table-cell header-cell table-action">
      Действия
    </div>
  }
</div>
